import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDWRy71b7QrAU8owggWNa1mQpqtjiiJBDQ",
  authDomain: "agentmiatest.firebaseapp.com",
  projectId: "agentmiatest",
  storageBucket: "agentmiatest.firebasestorage.app",
  messagingSenderId: "97168887618",
  appId: "1:97168887618:web:2a3da7390911df0fab82db"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);